const URLS = {
    // Auth URLs
    LOGIN: '#{API_URL}#/api/auth/login',
    AUTO_LOGIN: '#{API_URL}#/api/auth/auto-login',
    VERIFY_AUTH_COOKIE: '#{API_URL}#/api/auth/verify',
    RECONNECT: '#{API_URL}#/api/auth/reconnect',
    LOGOUT: '#{API_URL}#/api/auth/logout',
    PASSWORD_RECOVERY: '#{API_URL}#/api/auth/password/recovery',
    PASSWORD_RESET: '#{API_URL}#/api/auth/password/reset',

    // Customer URLs
    CUSTOMER: '#{API_URL}#/api/customer',
    COMPLETE_REGISTER: '#{API_URL}#/api/customer/register',

    // CompanyForm URLs
    COMPANY_FORM: '#{API_URL}#/api/company-form',

    // CompanyCategory URLs
    COMPANY_CATEGORY: '#{API_URL}#/api/company-category',

    // CreditPolicy URLs
    CREDIT_POLICY: '#{API_URL}#/api/credit-policy',

    // PlanGroup URLs
    PLAN_GROUP: '#{API_URL}#/api/plan-group',

    // CompanyUsageLog URLs
    USAGE_LOG: '#{API_URL}#/api/usage-log',

    // BatchFile URLs
    BATCH_FILE: '#{API_URL}#/api/credit-update/batch',

    // BypassCustomer URLs
    BYPASS_CUSTOMER: '#{API_URL}#/api/bypass-customer',

    // CompanyCustomer URL
    COMPANY_CUSTOMER: '#{API_URL}#/api/company-customer'
}

export default URLS
